import { useTMUHasTermsLanguagePairs } from 'providers/TranslationMemoryProviders/useTMUHasTermsLanguagePairs';
import { useMemo } from 'react';
import { Option } from 'types/Option';

interface IUseOptionsPairLanguagesTMOut {
  optionsLanguagesTM: Option[];
}

export default function useOptionsPairLanguagesTM(): IUseOptionsPairLanguagesTMOut {
  const { data: dataTMUHasTermsLanguagePairs } = useTMUHasTermsLanguagePairs({
    page: 1,
    query: '',
    currentLanguagePair: ''
  });

  const optionsLanguagesTM = useMemo(() => {
    return (dataTMUHasTermsLanguagePairs?.data.languagePairs?.map((lp) => ({
      value: lp.codes as string,
      label: lp.description as string
    })) ?? []) as Option[];
  }, [dataTMUHasTermsLanguagePairs?.data.languagePairs]);

  return { optionsLanguagesTM };
}
